export default __webpack_public_path__ + "static/media/3_addon_payment.15b97a51.svg";